import _ from 'underscore';
import ko from 'knockout';

export default function generate(param, viewModel) {
  if (_.isObject(param)) {
    const { depends, computedBy } = param;

    return ko.computed(() => {
      return computedBy(..._.map(depends, (dependency) => viewModel[dependency]()));
    });
  } else {
    return ko.observable(param);
  }
}
